import { AI_TIERS } from "@/constants/aiTiersCatalog";

/** Client-facing billing plans (no agency wholesale/profit labels). */
export const CLIENT_BILLING_TIERS = AI_TIERS.map((tier) => ({
  id: tier.id,
  badge: tier.badge,
  name: tier.name,
  shortName: tier.shortName,
  credits: tier.credits,
  creditsLabel: tier.creditsLabel,
  capacity: tier.capacity,
  monthlyPrice: tier.wholesale,
  systems: tier.systems,
  recommended: tier.id === 2,
}));

export const formatMonthlyPrice = (amount) => `$${amount} / month`;

export const getClientBillingTier = (id) =>
  CLIENT_BILLING_TIERS.find((tier) => tier.id === Number(id));
